/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { EventModel, EventPersonnelModel, PersonnelType } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class EventPersonnel<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags EventPersonnel
   * @name GetJudgesByEventDetail
   * @request GET:/EventPersonnel/GetJudgesByEvent/{eventId}
   */
  getJudgesByEventDetail = (eventId: number, params: RequestParams = {}) =>
    this.request<EventPersonnelModel[], any>({
      path: `/EventPersonnel/GetJudgesByEvent/${eventId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventPersonnel
   * @name GetJudgesByPageantDetail
   * @request GET:/EventPersonnel/GetJudgesByPageant/{pageantId}
   */
  getJudgesByPageantDetail = (pageantId: number, params: RequestParams = {}) =>
    this.request<EventPersonnelModel[], any>({
      path: `/EventPersonnel/GetJudgesByPageant/${pageantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventPersonnel
   * @name GetPersonnelByEventDetail
   * @request GET:/EventPersonnel/GetPersonnelByEvent:{eventId}
   */
  getPersonnelByEventDetail = (eventId: number, params: RequestParams = {}) =>
    this.request<EventPersonnelModel[], any>({
      path: `/EventPersonnel/GetPersonnelByEvent:${eventId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventPersonnel
   * @name AddJudgeToEventCreate
   * @request POST:/EventPersonnel/AddJudgeToEvent
   */
  addJudgeToEventCreate = (data: EventPersonnelModel, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/EventPersonnel/AddJudgeToEvent`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags EventPersonnel
   * @name AddPersonnelToEventCreate
   * @request POST:/EventPersonnel/AddPersonnelToEvent
   */
  addPersonnelToEventCreate = (data: EventPersonnelModel, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/EventPersonnel/AddPersonnelToEvent`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags EventPersonnel
   * @name RemovePersonnelFromEventDelete
   * @request DELETE:/EventPersonnel/RemovePersonnelFromEvent/{id}
   */
  removePersonnelFromEventDelete = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/EventPersonnel/RemovePersonnelFromEvent/${id}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventPersonnel
   * @name RemoveJudgeFromEventDelete
   * @request DELETE:/EventPersonnel/RemoveJudgeFromEvent/{id}
   */
  removeJudgeFromEventDelete = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/EventPersonnel/RemoveJudgeFromEvent/${id}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventPersonnel
   * @name GetEventsForJudgeDetail
   * @request GET:/EventPersonnel/GetEventsForJudge/{userId}
   */
  getEventsForJudgeDetail = (userId: number, params: RequestParams = {}) =>
    this.request<EventModel[], any>({
      path: `/EventPersonnel/GetEventsForJudge/${userId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventPersonnel
   * @name GetEventsForPersonnelDetail
   * @request GET:/EventPersonnel/GetEventsForPersonnel/{userId}
   */
  getEventsForPersonnelDetail = (userId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/EventPersonnel/GetEventsForPersonnel/${userId}`,
      method: 'GET',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventPersonnel
   * @name GetPersonnelTypesList
   * @request GET:/EventPersonnel/GetPersonnelTypes
   */
  getPersonnelTypesList = (params: RequestParams = {}) =>
    this.request<PersonnelType[], any>({
      path: `/EventPersonnel/GetPersonnelTypes`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
